import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import IntlMessages from '../../util/IntlMessages'
import { Button, Row, Col, Modal, Form } from 'antd'
import {
  loadSaleProgressModalShow,
  loadTempSalesOrderData
} from '../../appRedux/actions/Sell'
import { parkSale } from '../../appRedux/actions'

const SaleProgressModal = props => {
  const dispatch = useDispatch()

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getSaleProgressModalShow = useSelector(
    ({ Sell }) => Sell.saleProgressModalShow
  )
  const getTempSalesOrderData = useSelector(
    ({ Sell }) => Sell.tempSalesOrderData
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getReduxSalePaymentData = useSelector(
    ({ Sell }) => Sell.salePaymentData
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getDeletedProds = useSelector(({ MainSale }) => MainSale.deletedProds)

  const [
    getIsFullFillmentDetailsModalVisible,
    setIsFullFillmentDetailsModalVisible
  ] = React.useState(false)
  const [getMoreActionsOptions, setMoreActionsOptions] = React.useState([])
  const [getCurrentSaleStatusData, setCurrentSaleStatusData] = React.useState(
    {}
  )
  const [getIsSaleProgressModalVisible, setIsSaleProgressModalVisible] =
    React.useState(false)

  // React.useEffect(() => {
  //   let mounted = true;
  //   let selectedSaleOrderData = [];
  //   if (!isEmptyObject(getCurrentSalesOrderData)) {
  //     selectedSaleOrderData = getCurrentSalesOrderData;
  //     if (mounted) {
  //       if (selectedSaleOrderData.Products != undefined) {
  //         if (!isEmptyObject(selectedSaleOrderData.Products)) {
  //           //  setIsMoreActionButtonDisable(false);
  //           if (selectedSaleOrderData.Products.length > 0) {
  //             let moreActions = getMoreActionsOptions;
  //             let tempMoreActions =
  //               moreActions &&
  //               moreActions.map((e) => {
  //                 return {
  //                   OptionID: e.OptionID,
  //                   OptionName: e.OptionName,
  //                   IsDisabled: false,
  //                 };
  //               });
  //             setMoreActionsOptions(tempMoreActions);
  //           }
  //         }
  //       }
  //     }
  //   }

  //   return () => (mounted = false);
  // }, [getCurrentSalesOrderData]);

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getSaleProgressModalShow) {
        setIsSaleProgressModalVisible(true)
      } else {
        setIsSaleProgressModalVisible(false)
      }
    }

    return () => (mounted = false)
  }, [getSaleProgressModalShow])

  const handleClickSaleProgress = buttonType => {
    
    if (buttonType == 1) {
      // save and continue sale
      parkSale(
        getSaleOrderJson,
        getSalesOrderStatuses,
        getCurrentSalesOrderData,
        getTempSalesOrderData,
        getIsRefundSale,
        dispatch,
        getReduxSalePaymentData,
        sellSelAttributes,
        !getIsSalePaymentProcessStart ? sellActionLog : [],
        getDeletedProds ? getDeletedProds : [],
        isOnline
      )
    } else if (buttonType == 2) {
      // return to sale Progress
      dispatch(loadTempSalesOrderData({}))
    }
    dispatch(loadSaleProgressModalShow(false))
  }

  return (
    <Modal
    title={
      <strong>Sale is in Progress</strong>
      }
      transitionName=''
      maskTransitionName=''
      className='fullfillment-modal'
      visible={getIsSaleProgressModalVisible}
      onCancel={() => {
        handleClickSaleProgress(2)
      }}
      width={400}
      centered={true}
      footer={
        <>
        <Button type='primary' className='dk-btn-cancel' onClick={() => handleClickSaleProgress(2)} >
        <IntlMessages id='sell.sell.saleprogressmodal.returntosale' />
        </Button>

        <Button type='primary' className='dk-btn-add' onClick={() => handleClickSaleProgress(1)} >
        <IntlMessages id='sell.sell.saleprogressmodal.saveandcontinue' />
        </Button>

          ,
        </>
      }
    >
   
          <>
            <h2 className='dk-quick-modal-header'>
              <IntlMessages id='sell.sell.saleprogressmodal.holdup!' />
            </h2>
            <p className='mb-0 mt-2'>
              <IntlMessages id='sell.sell.saleprogressmodal.youhavea' />
            </p>
          </>
        
    </Modal>
  )
}

export default SaleProgressModal
